import {Component, ComponentRef, Input, ViewContainerRef} from '@angular/core';
import {SimpleWord} from '../../models/simple-word.model';
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {PitchPopupComponent} from "../pitch-popup/pitch-popup.component";
import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";


@Component({
  selector: 'app-word-record-btn',
  template: `
    <button type="button"
            *ngIf="word && word.wordVoice"
            class="option-btn type-2"
            (click)="openRecord($event)">
      <i class="ic ic-speak"></i>
    </button>
  `,
  styleUrls: ['./word-record-btn.component.scss'],
  host: { class: 'option-btn' },
})
export class WordRecordBtnComponent {
  @Input() word?: SimpleWord;

  private elementRefPopup: ComponentRef<PitchPopupComponent> | null = null;

  constructor(
    private container: ViewContainerRef,
    private dynamicSvc: DynamicComponentService,
    private globalEventSvc: GlobalEventService,
  ) { }

  public openRecord(event: MouseEvent): void {
    console.log('app-word-record-btn onRecord() click', this.word);
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event);

    if (!this.word) {
      throw new Error('WordRecordBtnComponent::openRecord() word is null');
    }

    this.elementRefPopup = this.dynamicSvc.createComponent(PitchPopupComponent, this.container)

    this.elementRefPopup.instance.close.subscribe(result => {
      console.log('WordRecordBtnComponent::openRecord() = ', result);

      this.closePopup();
    });
    this.elementRefPopup.instance.word = this.word;
    this.elementRefPopup.changeDetectorRef.detectChanges();
  }

  /**
   * 팝업창 닫기
   */
  private closePopup() {
    if (this.elementRefPopup) {
      this.elementRefPopup.destroy();
      this.elementRefPopup = null;
    }
  }
}
